<template>
  <div>
    <Head title="Generované kalkulace" />
    <h1 class="mb-8 text-3xl font-bold">Generované kalkulace</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Verze:</label>
        <select v-model="form.version" class="form-select mt-1 w-full">
          <option :value="null">Všechny</option>
          <option value="latest">Pouze poslední verze</option>
        </select>
      </search-filter>
      <!-- <Link class="btn-indigo" href="/components/create">
        <span>Vytvořit</span>
        <span class="hidden md:inline">&nbsp;komponentu</span>
      </Link> -->
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">OP (verze)</th>
            <th class="pb-4 pt-6 px-6">Autor</th>
            <th class="pb-4 pt-6 px-6">Vytvořeno</th>
            <th class="pb-4 pt-6 px-6">Cena</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="calculation in calculations.data" :key="calculation.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link :href="`/generated-calculations/${calculation.id}`" class="flex flex-col items-start justify-center px-6 py-2.5 focus:text-indigo-500 leading-normal">
                {{ calculation.case_code }} (v.{{ calculation.version }})<span class="text-gray-500 text-sm">{{ calculation.type }}</span>
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-2.5" :href="`/generated-calculations/${calculation.id}`" tabindex="-1">
                {{ calculation.user_name }}
              </Link>
            </td>
            <td class="border-t">
              <Link :href="`/generated-calculations/${calculation.id}`" class="flex items-center px-6 py-2.5">{{ calculation.created_at }}</Link>
            </td>
            <td class="border-t">
              <Link :href="`/generated-calculations/${calculation.id}`" class="flex flex-col items-start justify-center px-6 py-2.5 focus:text-indigo-500 leading-normal">
                {{ calculation.price_with_tax }}<span class="text-gray-500 text-sm">{{ calculation.price_without_tax }} bez DPH</span>
              </Link>
            </td>
          </tr>

          <tr v-if="calculations.data.length === 0">
            <td class="px-6 py-2.5 border-t" colspan="4">Zatím není uložena žádná kalkulace</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="calculations.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    calculations: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        version: this.filters.version,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/generated-calculations', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
